import React, { Component } from 'react';
import jump from 'jump.js';
import classNames from 'classnames/bind';
import { Link } from '@reach/router';

import styles from './index.module.scss';

import { Translation } from 'react-i18next';
import { history } from '../../utils/router-history';
import CDNImage from '../../utils/CDNImage';

let cx = classNames.bind(styles);
class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isExpanded: 'hidden',
		};
	}

	toggleExpansion = e => {
		const { isExpanded } = this.state;
		e.preventDefault();
		this.setState({
			isExpanded: isExpanded === 'hidden' ? '' : 'hidden',
		});
	};

	navigateTo = section => {
		if (this.props.page && this.props.page === 'home') {
			jump(`section#${section}`, {
				offset: -90,
				duration: 1000,
			});
		} else {
			this.navigateToHome(section);
		}
	};

	navigateToHome = section => {
		history.navigate('/#' + section, { replace: true });
	};

	render() {
		const { isExpanded } = this.state;
		let navMenuClass = classNames({
			'cursor-pointer menu-items text-base font-bold inline-block no-underline px-3 text-tcn-black font-Avenir-Black': true,
		});

		let navMenuClassOp = classNames({
			'cursor-pointer menu-items text-base inline-block font-bold uppercase no-underline py-2 px-2 text-black rounded-md border-2 border-tcn-red font-Avenir-black': true,
		});

		let toggleColourClass = classNames({
			'no-underline hover:no-underline': true,
		});

		let navContentClass = classNames({
			'hidden w-full flex-grow lg:flex lg:items-center lg:w-auto lg:block mt-0 lg:mt-0 px-4 lg:px-10 z-20': true,
			[`${isExpanded}`]: true,
		});

		let navContentClassMobile = classNames({
			'lg:hidden w-full py-5 flex-grow lg:w-9/12 lg:flex-col lg:items-center  lg:justify-center lg:w-auto lg:block mt-0 lg:mt-0 px-4 lg:px-10 z-20': true,
			[`${isExpanded}`]: true,
		});


		const menu_list = [
			{ link: 'nosotros', name: 'layout.menu.who_we_are', class: '' },
			{ link: 'marcas', name: 'layout.menu.trademark', class: '' },
			{ link: 'areas', name: 'layout.menu.areas', class: 'hidden lg:flex'},
			{ link: 'office_tour', name: 'layout.menu.office', class: '' },
			{ link: 'sustentabilidad', name: 'layout.menu.sustentabilidad', class: 'hidden lg:flex' },
			{ link: 'testimonios', name: 'layout.menu.testimonials', class: 'hidden lg:flex' },
			{ link: 'beneficios', name: 'layout.menu.benefits', class: '' },
		];
		const menu_mobile_list = [
			{ link: 'nosotros', name: 'layout.menu.who_we_are', class: '' },
			{ link: 'marcas', name: 'layout.menu.trademark', class: '' },
			{ link: 'office_tour', name: 'layout.menu.office', class: '' },
			{ link: 'beneficios', name: 'layout.menu.benefits', class: '' },
		];

		return (
			<nav
				id='header'
				className={cx({
					header: true,
					'bg-white w-full': true,
				})}
			>
				<div className='w-full mx-auto flex flex-wrap items-center justify-between mt-0 py-5'>
					<div className='pl-8 flex items-center'>
						<a
							className={toggleColourClass}
							onClick={() => history.navigate('/')}
						>
							<CDNImage
								className='w-full'
								image_name={'ideal_logo.png'}
								alt='Logo'
							/>
						</a>
					</div>

					<div className='block lg:hidden pr-4'>
						<button
							id='nav-toggle'
							className='flex items-center p-1 bg-tcn-red hover:border-tcn-dark-blue'
							onClick={this.toggleExpansion}
						>
							<svg
								className='fill-current h-6 w-6'
								viewBox='0 0 20 20'
								xmlns='http://www.w3.org/2000/svg'
							>
								<title>Menu</title>
								<path d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z' />
							</svg>
						</button>
					</div>

					<div className={navContentClass} id='nav-content'>
						<ul className='list-reset flex justify-end flex-1 items-center'>
							{menu_list.map(menu => (
								<li key={menu.link.toString()} className='mr-2 pointer'>
									<span
										className={navMenuClass}
										href='#'
										onClick={() => this.navigateTo(menu.link)}
									>
										<Translation>{t => <p className='font-bold font-Avenir-Black'>{t(menu.name)}</p>}</Translation>
									</span>
								</li>
							))}
							<li className='mr-2 pointer'>
								<Link id='navAction' to='/ofertas' className={navMenuClassOp}>
									<Translation>
										{t => <p className='font-Avenir-Black'>{t('layout.menu.opportunities')}</p>}
									</Translation>
								</Link>
							</li>
						</ul>
					</div>
					<div className='lg:hidden w-full mx-auto flex flex-row items-center justify-between mt-0'>
						<div className={navContentClassMobile} id='nav-content'>
							<ul className='list-reset lg:flex justify-end flex-1 items-center'>
								{menu_mobile_list.map(menu => (
									<li key={menu.link.toString()} className='my-4 mr-2 pointer'>
										<span
											className={navMenuClass}
											href='#'
											onClick={() => this.navigateTo(menu.link)}
										>
											<Translation>{t => <p className='font-bold font-Avenir-Black'>{t(menu.name)}</p>}</Translation>
										</span>
									</li>
								))}
								<li className='mr-2 pointer'>
									<Link id='navAction' to='/ofertas' className={navMenuClassOp}>
										<Translation>
											{t => <p className='font-Avenir-Black'>{t('layout.menu.opportunities')}</p>}
										</Translation>
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</nav>
		);
	}
}

export default Header;
